/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import App from "../../layout/App";

import "./styles.css";
import ilusAluno from "../../assets/img/ilus-alunos.svg";
import ilusProfissional from "../../assets/img/ilus-profissionais.svg";
import ilusDiretores from "../../assets/img/ilus-diretores.svg";
import ilusTurma from "../../assets/img/ilus-turma.svg";
import iconeClose from "../../assets/img/icone-close.svg";
import api from "../../utils/api";
import Loading from "../../Components/Loading";
import Button from "../../Components/button";
import loading from "../../assets/gifs/loading.gif";
import { saveAs } from "file-saver";
import MessageTitle from "../../Components/MessageTitle";
import { TfiReload } from 'react-icons/tfi'
import { TbFileDownload } from 'react-icons/tb'
import { AiOutlineFileSync } from 'react-icons/ai'
import { MessageContext } from "../../context/message";
import { DataSchoolContext } from "../../context/dataSchool";

function Home(props) {
  const [fileDetails, setfileDetails] = useState({
    startGeneration: false,
    completeGeneration: false,
    downloaded: false,
  });
  const [isLoading, setLoading] = useState(true);
  const [infoApp, setInfoApp] = useState({});
  const [modal, setModal] = useState(false);
  const { setErrorMessage } = useContext(MessageContext);
  const {dataSchool , getDataSchool} = useContext(DataSchoolContext)
  
  useEffect(() => {
  
 
    getDataSchool()
 setLoading(false)

    const completeGeneration = localStorage.getItem("completeGeneration") !== null
      ? localStorage.getItem("completeGeneration")
      : false;
    const startGeneration =
      localStorage.getItem("startGeneration") !== null
        ? localStorage.getItem("startGeneration")
        : false;
    const downloaded =
      localStorage.getItem("downloaded") !== null
        ? localStorage.getItem("downloaded")
        : false;
    setInfoApp(JSON.parse(sessionStorage.getItem("info-app")));

    setfileDetails({ completeGeneration, startGeneration, downloaded });
  }, []);

  function handleModal(e) {
    e.preventDefault();
    setModal(!modal);
  }


  async function gerarArquivo() {
    let inep = sessionStorage.getItem("inep");
    let user = JSON.parse(sessionStorage.getItem("HomeLog"));
    localStorage.setItem("completeGeneration", false);
    localStorage.setItem("startGeneration", true);
    setfileDetails({
      ...fileDetails,
      startGeneration: true,
      completeGeneration: false,
    });
    await api.get(`/file/generate-file?inep=${inep}&iescolar=${user.idCenso}`)
      .then((response) => {
        setfileDetails({
          ...fileDetails,
          startGeneration: false,
          completeGeneration: true,
        });
        localStorage.setItem("completeGeneration", true);
        localStorage.setItem("startGeneration", false);
        setErrorMessage([{ message: "Arquivo gerado com sucesso", ok: true }])
      })
      .catch((err) => {
        setErrorMessage([{ message: "Erro ao gerar o arquivo!", ok: false }])
        setfileDetails({
          ...fileDetails,
          startGeneration: false,
          completeGeneration: false,
        });
        localStorage.setItem("startGeneration", false);
      });

    
  }

  async function BaixarArquivo() {
    let blob;
    let inep = sessionStorage.getItem("inep");
    await api
      .get(`/file/get-file/${inep}`)
      .then((response) => {
        blob = new Blob([response.data], { type: "text/plain;charset=utf-8" });
        saveAs(blob, `${inep}.txt`);
        setfileDetails({
          ...fileDetails,
          downloaded: true,
          completeGeneration: true,
        });
        localStorage.setItem("downloaded", true);
        setErrorMessage([{ message: "Download feito com sucesso!", ok: true }])
      })
      .catch((err) => {
        setErrorMessage([{ message: "erro ao realizar o Download do arquivo!", ok: false }])
        localStorage.setItem("downloaded", false);
      });
  }
  function GerarNovamente() {
    localStorage.setItem("completeGeneration", false);
    localStorage.setItem("startGeneration", false);
    localStorage.setItem("downloaded", false);
    setfileDetails({
      downloaded: false,
      completeGeneration: false,
      startGeneration: false,
    });
  }

  return (
    <>
      {isLoading && <Loading />}
      <div
        className="modal-arquivo"
        onClick={(e) => handleModal(e)}
        style={{ display: modal ? "flex" : "none" }}
      >
        <div className="container-arquivo" onClick={(e) => e.stopPropagation()}>
          <div className="box1">
            <div className="headModal">
              <h1>Exportação dos dados para o Educacenso</h1>
            </div>
            <div className="button-close">
              <img
                width={28}
                onClick={(e) => handleModal(e)}
                src={iconeClose}
                alt="Fechar"
              />
            </div>
          </div>
          <div className="box-arquivo">
            <div
              style={{
                display: !fileDetails.startGeneration ? "block" : "none",
              }}
            >
              {!fileDetails.startGeneration && !fileDetails.completeGeneration ? (
                <p>
                  TUDO PRONTO! GERE AQUI SEU ARQUIVO DE EXPORTAÇÃO DO CENSO.
                </p>
              ) : (
                ""
              )}
            </div>

            <div
              className="box-arquivo"
              style={{ display: fileDetails.startGeneration || fileDetails.completeGeneration ? "flex" : "none" }}
            >
              {!fileDetails.completeGeneration ? (
                <p>GERANDO ARQUIVO AGUARDE...</p>
              ) : (
                <p>ARQUIVO PRONTO PARA DOWNLOAD</p>
              )}
            </div>
          </div>
          <div
            style={{
              display: fileDetails.startGeneration === true ? "flex" : "none",
            }}
            className="box-loading"
          >
            <img src={loading} alt="" className="arquivo-loading" />
          </div>
          <div className="container-modal-download">
            <div
              className="button-salvar1"
              style={{
                display:
                  !fileDetails.startGeneration &&
                    !fileDetails.completeGeneration
                    ? "flex"
                    : "none",
              }}
            >
              <Button
                title="Gerar arquivo"
                icon={<AiOutlineFileSync size={20} color="#fff" />}
                onClick={(e) => gerarArquivo()}
                style={{
                  backgroundColor: "green",
                  width: "120px",
                  height: "40px",
                  marginTop: "10px",
                }}
              />
            </div>
            <div
              className="button-salvar1"
              style={{
                display: fileDetails.completeGeneration ? "flex" : "none",
              }}
            >
              <Button
                title="Baixar arquivo"
                icon={<TbFileDownload size={25} color="#fff" />}
                onClick={(e) => BaixarArquivo()}
                disabled={!fileDetails}
                style={{
                  backgroundColor: "green",
                  width: "120px",
                  height: "40px",
                  marginTop: "10px",
                }}
              />
            </div>
            <div
              className="button-salvar1"
              style={{
                display: fileDetails.completeGeneration ? "flex" : "none",
              }}
            >
              <Button
                icon={<TfiReload size={20} color="#fff" />}
                title="Gerar novamente"
                onClick={(e) => GerarNovamente()}
                disabled={!fileDetails}
                style={{
                  backgroundColor: "green",
                  width: "120px",
                  height: "40px",
                  marginTop: "10px",
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <App visibled={false}>
        {dataSchool === null ? (
          <MessageTitle
            style={{ marginTop: 50 }}
            message="Erro ao carregar os dados"
          />
        ) : (
          <div id="bloco-corpo">
            <div className="card-perfil">
              {infoApp.enableExportFile ? (
                <button id="button-modal" onClick={(e) => handleModal(e)}>
                  {" "}
                  Exportar Arquivo
                </button>
              ) : (
                <div />
              )}
            </div>
            <div id="bloco-info-escola">
              <div className="bloco-info">
                <h5>Número de Alunos</h5>
                <div className="info">
                  <h2>{dataSchool?.theAmountStudents}</h2>
                  <img src={ilusAluno} alt="" />
                </div>
              </div>
              <div className="bloco-info">
                <h5>Número de Profissionais</h5>
                <div className="info">
                  <h2>{dataSchool?.theAmountProfessionals}</h2>
                  <img src={ilusProfissional} alt="" />
                </div>
              </div>
              <div className="bloco-info">
                <h5>Número de Diretores</h5>
                <div className="info">
                  <h2>{dataSchool?.theAmountSchoolManager}</h2>
                  <img src={ilusDiretores} alt="" />
                </div>
              </div>
              <div className="bloco-info">
                <h5>Número de Turmas</h5>
                <div className="info">
                  <h2>{dataSchool?.theAmountClass}</h2>
                  <img src={ilusTurma} alt="" />
                </div>
              </div>
            </div>

            {infoApp.enableInfoBoard ? (
              <div
                id="quadro"
                dangerouslySetInnerHTML={{ __html: infoApp.informationBoard }}
              />
            ) : (
              <div />
            )}
          </div>
        )}
      </App>
    </>
  );
}
export default Home;
